export enum ProductType {
	PA = 'PA',
	QD = 'QD',
	AI = 'AI',
}
